export default __webpack_public_path__ + "63a22d9a7aaee29cb69782ad35cf4377.png";